import { createSlice } from "@reduxjs/toolkit";

// Get initial value from localStorage or default to false
const storedGoogleAuth = localStorage.getItem("isGoogleAuth") === "true";

const initialState = {
  userdata: [],
  folderList: [],
  rootFolderList: [], // Separate array for root folders
  sharedFolderList: [], // Separate array for shared folders
  folderCounter: 0,
  counter: 0,
  folderName: "",
  isSharedValue: false, // New boolean variable
  setParentFolderName: "",
  isGoogleAuth: storedGoogleAuth,
};

const fileSlicer = createSlice({
  name: "getdata",
  initialState,
  reducers: {

    setGoogleAuth: (state, action) => {
      state.isGoogleAuth = action.payload;
      localStorage.setItem("isGoogleAuth", action.payload); // sync with localStorage
    },

    addToken: (state, action) => {
      const exists = state.userdata.some(
        (user) => user.id === action.payload.id
      );
      if (!exists) {
        state.userdata.push({
          id: action.payload.id,
          Files: action.payload.Files,
          isShared: action.payload.isShared, // Storing isShared
        });
      }
      // console.log("userData", state.userdata[0]);
    },
    setIsSharedFalse: (state) => {
      state.folderName = '';
      // console.log("Folder path cleared", state.folderName);
        state.isSharedValue = false;
        // console.log("state.isSharedValue SADvSD",state.isSharedValue)
      },
    setIsSharedValue: (state, action) => {
      state.isSharedValue = action.payload; // Update isSharedValue
      // console.log("state.isSharedValue :" ,state.isSharedValue)
    },

    setParentFolderName: (state, action) => {
      state.fileName = action.payload; // Update fileName
      // console.log("Updated fileName:", state.fileName); // Log the updated fileName
    },

    addFolder: (state, action) => {
        if (Array.isArray(action.payload)) {
            const folderData = { [state.folderCounter]: action.payload };
    
            // Determine whether to update root or shared folders based on isSharedValue
            if (state.isSharedValue) {
                state.sharedFolderList.push(folderData);
                // console.log("Shared Folder List Updated:", state.sharedFolderList);
            } else {
                state.rootFolderList.push(folderData);
                // console.log("Root Folder List Updated:", state.rootFolderList);
            }
        } else {
            // console.error("Invalid payload in addFolder", action.payload);
        }
    },
    

    addNewFolder: (state, action) => {
      // Set folderCounter to 1
      state.folderCounter = 1;

      // Check if the payload is an array
      if (Array.isArray(action.payload)) {
        // Replace folderList with only the 0th index from the payload
        state.folderList = [action.payload[0]];
      } else {
        // console.error("Payload is not in the expected format");
      }
    },

    removeLastFolder: (state) => {
      // Check if folderList is not empty
      if (state.rootFolderList.length > 0) {
        // Remove the last record
        state.rootFolderList.pop();
      } else {
        // console.error("No records to remove");
      }
    },
    removeLastFolder2: (state) => {
      // Check if folderList is not empty
      if (state.sharedFolderList.length > 0) {
        // Remove the last record
        state.sharedFolderList.pop();
        // console.log("state.sharedFolderList",state.sharedFolderList)
      } else {
        // console.error("No records to remove");
      }
    },
    
    incrementCounter: (state) => {
      state.counter += 1;
      // console.log("incrementCounter counter state", state.counter)
    },
    incrementFCounter: (state) => {
      state.folderCounter += 1;
      // console.log("incrementFCounter folderCounter", state.folderCounter)

    },
    removeLastToken: (state) => {
      if (state.userdata.length > 0) {
        state.userdata.pop();
      }
    },
    decrementCounter: (state) => {
      state.counter -= 1;
      // console.log("decrementCounter counter",state.counter)

    },
    decrementFCounter: (state) => {
      state.folderCounter -= 1;
      // console.log("decrementFCounter folderCounter",state.folderCounter)
    },
    resetUserData: (state) => {
      state.userdata = [];
    },
    resetCounter: (state) => {
      state.counter = 0;
      // console.log("Counter reset to", state.counter);
    },
    resetFCounter: (state) => {
      state.folderCounter = 0;
      // console.log("Counter reset to", state.folderCounter);
    },
    resetFolderList: (state) => {
        // Reset folderCounter to 1
        state.folderCounter = 1;
      
        // Keep only the first item in folderList, rootFolderList, and sharedFolderList
        state.folderList = state.folderList.length > 0 ? [state.folderList[0]] : [];
        state.rootFolderList = state.rootFolderList.length > 0 ? [state.rootFolderList[0]] : [];
        state.sharedFolderList = state.sharedFolderList.length > 0 ? [state.sharedFolderList[0]] : [];
      },
      
      setFolderPath: (state, action) => {
      
        state.folderName = action.payload.folderPath;
        // console.log("state.folderName",state.folderName)
        state.isShared = action.payload.isShared; // Store isShared value
      },
    
    
    
    

    replacelasttoken: (state, action) => {
      if (state.userdata.length > 0) {
        state.userdata.pop();
        state.userdata.push(action.payload);
      }
    },
    breadCrum: (state, action) => {
      const validNumber = Number(action.payload.number);
      // console.log("validNumber", validNumber);

      // console.log("userdata breadCrum", state.userdata);
      if (state.userdata.length > 0) {
        // console.log("another", state.userdata.length, validNumber);
        const ans = state.userdata.length - 1 - validNumber;

        // console.log("beyblade", validNumber, ans);

        if (ans >= 0 && ans <= state.userdata.length) {
          for (var i = 1; i < ans; i++) {
            state.userdata.pop();
            state.counter--;
          }
        }
      } else {
        // console.log("Userdata is empty!");
      }
    },
  },
});

export const {
  setGoogleAuth,
  addToken,
  setIsSharedValue,
  setParentFolderName,
  addFolder,
  addNewFolder,
  resetFCounter,
  incrementCounter,
  removeLastToken,
  decrementCounter,
  resetUserData,
  resetCounter,
  setFolderPath,
  incrementFCounter,
  setIsSharedFalse,
  removeLastFolder,
  decrementFCounter,
  replacelasttoken,
  breadCrum,
  resetFolderList,
  removeLastFolder2
} = fileSlicer.actions;
export default fileSlicer.reducer;
